import { tickerHeadlines } from "@/mocks/posts";

export default function TickerBar() {
  const loop = [...tickerHeadlines, ...tickerHeadlines];

  return (
    <div className="w-full bg-primary-500">
      <div className="flex items-center w-full">
        <div className="flex shrink-0 items-center gap-2 bg-primary-700 px-4 md:px-6 py-3 text-sm font-semibold text-background-50">
          <i className="ri-fire-fill animate-pulse" aria-hidden="true"></i>
          <span className="whitespace-nowrap">今日爆点</span>
        </div>
        <div className="relative flex-1 overflow-hidden py-3">
          <div className="flex w-max animate-marquee items-center gap-8 pl-6">
            {loop.map((headline, index) => (
              <span
                key={`${headline}-${index}`}
                className="flex items-center gap-3 text-sm text-background-50/95 whitespace-nowrap"
              >
                <i className="ri-live-line text-accent-300" aria-hidden="true"></i>
                {headline}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}